module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN301_776863078.3c555222.png";